// Libraries
import {
  Directive,
  HostListener,
  Input,
  HostBinding
} from '@angular/core';

/**
 * Directive to show/hide element based on scroll offset.
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@Directive({
    selector: '[wpScrollVisible]'
})
export class ScrollVisibleDirective {
  // Public properties
  /**
   * Scroll offset.
   */
  @Input('scrollOffsetVisible') scrollOffsetVisible = 0;
  /**
   * Flag to mantain if element should has hidden class or not.
   */
  @HostBinding('style.display') display = 'none';
  /**
   * Bind window scroll event
   */
  @HostListener('window:scroll', ['$event']) scroll(target: any) {
    // Handles scroll event
    this.checkVisibility(target);
  }

  // Private methods
  /**
   * Check current element visibility.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof ScrollVisibleDirective
   */
  private checkVisibility($event: any) {
    this.display = ($event.srcElement.scrollingElement.scrollTop > this.scrollOffsetVisible) ? 'block' : 'none';
  }
}
